<template>
  <div class="select-option-container">
    <button type="button" class="btn btn-link btn-close" @click.stop="onRemoved" v-if="removeable">
      <i class="fas fa-times"></i>
    </button>
    <multiselect
      :value="value"
      :options="options.map(item => item.id)"
      :placeholder="placeholder"
      :custom-label="showCustomLabel"
      :showLabels="false"
      :clearOnSelect="false"
      :preserveSearch="true"
      @input="onSelected"
      @search-change="onSearchChange">
      <template slot="noResult" slot-scope="props">
        <span class="no-result">ไม่พบ '{{props.search}}' ที่กำลังค้นหา</span>
      </template>
      <template slot="noOptions">
        <span class="no-options">ไม่พบข้อมูลที่กำลังหา</span>
      </template>
      <span slot="caret"
        class="arrow">
        <i class="fas fa-angle-down"></i>
      </span>
    </multiselect>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */

import _ from 'lodash';
import Multiselect from 'vue-multiselect';

export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      default: null,
    },
    removeable: {
      type: Boolean,
      default: true,
    },
    customLabel: {
      type: String,
      default: 'title',
    },
    placeholder: {
      type: String,
      default: 'เลือก',
    },
  },
  components: {
    Multiselect,
  },
  methods: {
    showCustomLabel(selectedOption) {
      const option = _.find(this.options, (x) => x.id === selectedOption);
      return _.get(option, this.customLabel, null);
    },
    onRemoved() {
      this.$emit('onChanged', null);
    },
    onSelected(selectedOption) {
      this.$emit('onChanged', selectedOption);
    },
    onSearchChange(q) {
      this.$emit('onSearch', { q });
    },
  },
};
</script>
